const { debounce, getElements } = window.BAO.Utils

/**
 * Keeps promo cards (.clc-Promotion) in sync with the product cards in the
 * same grid row, so .clc-Promotion_Content can size its footer to match and
 * keep the promo's image bottom level with the product images beside it.
 *
 * A promo's <li> grid area always ends at the bottom of the last row it
 * spans (CSS Grid places it there regardless of what its sticky/flex
 * children render like), so each promo is matched to whichever product-card
 * row shares that same bottom edge, and reads --Dynamic_Card-footer from
 * that row's footer height - a single page-wide max would only be correct
 * for the one row that happens to hold the tallest footer on the page.
 */

const resizeObserver = new ResizeObserver(debounce(refresh, 200))

function syncPromoFooterHeights (grid) {
  const footers = getElements('.prd-Card_Footer', { context: grid })
  const promoItems = getElements('.prd-List_Item-media', { context: grid })

  if (!footers.length || !promoItems.length) return

  const footerRows = footers.map((footer) => ({
    bottom: Math.round(
      footer.closest('.prd-List_Item').getBoundingClientRect().bottom,
    ),
    height: footer.offsetHeight,
  }))

  promoItems.forEach((promoItem) => {
    const promoBottom = Math.round(promoItem.getBoundingClientRect().bottom)
    const rowHeights = footerRows
      .filter((row) => row.bottom === promoBottom)
      .map((row) => row.height)

    // No product row shares the promo's bottom edge (e.g. on mobile, where
    // this alignment isn't used) - leave any previously set value in place.
    if (!rowHeights.length) return

    promoItem.style.setProperty(
      '--Dynamic_Card-footer',
      `${Math.ceil(Math.max(...rowHeights))}px`,
    )
  })
}

function refresh () {
  // Re-observing from scratch is simplest and avoids leaking observations on
  // footers removed by Load More/filter re-renders (they get swapped for new
  // nodes rather than mutated in place).
  resizeObserver.disconnect()

  getElements('.prd-List_Items').forEach((grid) => {
    syncPromoFooterHeights(grid)

    getElements('.prd-Card_Footer', { context: grid }).forEach((footer) =>
      resizeObserver.observe(footer),
    )
  })
}

function init () {
  refresh()

  // Covers Load More and filtered Section-Rendering updates, both of which
  // replace product cards inside <collection-filters> rather than resizing
  // anything - the ResizeObserver above won't see those on its own.
  getElements('collection-filters').forEach((filters) => {
    new MutationObserver(debounce(refresh, 200)).observe(filters, {
      childList: true,
      subtree: true,
    })
  })
}

document.addEventListener('DOMContentLoaded', init)
